import React from "react";
import { Loader2 } from "lucide-react";

const GOLD = "#D9B300";

const METRICS = [
  ["Equipo", "team", false],
  ["Categoría", "category", false],
  ["Convocatorias", "callups", true],
  ["Partidos", "matches", true],
  ["Titular", "starts", true],
  ["Goles", "goals", true],
  ["Minutos", "minutes", true],
  ["T. amarillas", "yellow", true],
  ["T. rojas", "red", true],
];

export const RffmSeasonsCompare = ({ cols, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-500 py-3" data-testid="rffm-seasons-loading">
        <Loader2 className="h-4 w-4 animate-spin" /> Consultando temporadas RFFM…
      </div>
    );
  }
  const seasons = [...new Set((cols || []).flatMap((c) => (c.seasons || []).map((s) => s.season)))]
    .filter(Boolean).sort().reverse();
  if (!seasons.length) {
    return (
      <div className="text-xs text-slate-400 italic py-2" data-testid="rffm-seasons-empty">
        Sin datos RFFM de temporadas para los jugadores seleccionados.
      </div>
    );
  }
  return (
    <div className="space-y-4" data-testid="rffm-seasons-compare">
      <div className="text-xs font-black uppercase tracking-widest text-purple-700 pt-2">
        Temporadas RFFM
      </div>
      {seasons.map((season) => {
        const bySlot = cols.map((c) => (c.seasons || []).find((s) => s.season === season) || null);
        const best = {};
        METRICS.forEach(([, key, numeric]) => {
          if (!numeric) return;
          const vals = bySlot.map((s) => (typeof s?.[key] === "number" ? s[key] : null)).filter((v) => v !== null);
          if (vals.length > 1) best[key] = Math.max(...vals);
        });
        return (
          <div key={season} className="overflow-x-auto" data-testid={`rffm-season-${season}`}>
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-purple-700 text-white">
                  <td className="px-2 py-1.5 text-[10px] font-black uppercase tracking-widest whitespace-nowrap rounded-l-md">
                    {season}
                  </td>
                  {cols.map((c) => (
                    <td key={c.id} className="px-2 py-1.5 text-center text-xs font-bold last:rounded-r-md">{c.name}</td>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {METRICS.map(([label, key, numeric]) => (
                  <tr key={key}>
                    <td className="px-2 py-1.5 text-[10px] uppercase tracking-widest text-slate-500 whitespace-nowrap">{label}</td>
                    {cols.map((c, i) => {
                      const v = bySlot[i]?.[key];
                      const isBest = numeric && best[key] !== undefined && v === best[key];
                      return (
                        <td key={c.id} className="px-2 py-1.5 text-center">
                          <span
                            className={`inline-block px-2 py-0.5 rounded font-bold ${isBest ? "text-slate-900" : "text-slate-700"}`}
                            style={isBest ? { backgroundColor: `${GOLD}33`, border: `1px solid ${GOLD}` } : {}}
                          >
                            {v ?? "—"}
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
      <p className="text-[10px] text-slate-400">
        Fuente: ficha oficial del jugador en rffm.es · Los minutos pueden ser estimados.
      </p>
    </div>
  );
};

export default RffmSeasonsCompare;
